// src/components/ui/button/PlanButton.js
import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./PlanButton.scss";
import infoIcon from "./img/info-icon.svg";
import tickIcon from "./img/tick.svg";

const PlanButton = ({ text, infoText, onClick, isActive, isAmount, amount }) => {
  return (
    <button className={`plan-button ${isActive ? 'active' : ''}`} onClick={onClick}> 
      <span className="left-icon">
        <img src={tickIcon} alt="Tick" className="upload-icon" />
      </span> 
      <span className="button-text">
        {text}
        <OverlayTrigger
        placement="top"
        overlay={<Tooltip
          id="tooltip"
          html
        >
          <div className='tooltip-div' dangerouslySetInnerHTML={{ __html: infoText }} />
        </Tooltip>}
      >
          <img src={infoIcon} alt="Info Icon" className="info-icon-margin" />
      </OverlayTrigger>
      </span>
      {isAmount && <span className='plan-cost'>
        OMR {amount}
      </span>}
    </button>
  );
};

PlanButton.propTypes = {
  text: PropTypes.string.isRequired,
  infoText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default PlanButton;
